import { REFERENCE_CLIENT_LOGOS } from '../lib/siteAssets';

export interface ReferenceClient {
  id: string;
  name: string;
  shortName: string;
  logoUrl?: string;
  logoInitials: string;
  /** Links to a testimonial id — if set, client also appears in scrolling cards */
  testimonialId?: string;
  sector?: string;
  active: boolean;
  order: number;
}

export const mockReferenceClients: ReferenceClient[] = [
  {
    id: 'rc-001',
    name: 'Istanbul Ready-to-Wear & Apparel Exporters\' Association',
    shortName: 'İHKİB',
    logoInitials: 'İHKİB',
    logoUrl: REFERENCE_CLIENT_LOGOS.ihkib,
    testimonialId: '1',
    sector: 'Exporters Association',
    active: true,
    order: 1,
  },
  {
    id: 'rc-002',
    name: 'Karaisalı District Governorship',
    shortName: 'Karaisalı',
    logoInitials: 'KRS',
    logoUrl: REFERENCE_CLIENT_LOGOS.karaisali,
    testimonialId: '2',
    sector: 'Government',
    active: true,
    order: 2,
  },
  {
    id: 'rc-003',
    name: 'Izmir Development Agency',
    shortName: 'İZKA',
    logoInitials: 'İZKA',
    logoUrl: REFERENCE_CLIENT_LOGOS.izka,
    testimonialId: '3',
    sector: 'Development Agency',
    active: true,
    order: 3,
  },
  {
    id: 'rc-004',
    name: 'Mediterranean Exporters\' Associations',
    shortName: 'AKİB',
    logoInitials: 'AKİB',
    logoUrl: REFERENCE_CLIENT_LOGOS.akib,
    testimonialId: '4',
    sector: 'Exporters Association',
    active: true,
    order: 4,
  },
  {
    id: 'rc-005',
    name: 'Bursa Eskişehir Bilecik Kalkınma Ajansı',
    shortName: 'BEBKA',
    logoInitials: 'BEBKA',
    logoUrl: REFERENCE_CLIENT_LOGOS.bebka,
    sector: 'Development Agency',
    active: true,
    order: 5,
  },
  {
    id: 'rc-006',
    name: 'Kuzey Anadolu Kalkınma Ajansı',
    shortName: 'OKA',
    logoInitials: 'OKA',
    logoUrl: REFERENCE_CLIENT_LOGOS.oka,
    sector: 'Development Agency',
    active: true,
    order: 6,
  },
  {
    id: 'rc-007',
    name: 'Türkiye Petrol Rafinerileri A.Ş.',
    shortName: 'TÜPRAŞ',
    logoInitials: 'TPRS',
    logoUrl: REFERENCE_CLIENT_LOGOS.tupras,
    sector: 'Energy & Petrochemical',
    active: true,
    order: 7,
  },
  {
    id: 'rc-008',
    name: 'IFC — International Finance Corporation',
    shortName: 'IFC',
    logoInitials: 'IFC',
    logoUrl: REFERENCE_CLIENT_LOGOS.ifc,
    sector: 'International Finance',
    active: true,
    order: 8,
  },
  {
    id: 'rc-009',
    name: 'İzmir Büyükşehir Belediyesi',
    shortName: 'İzmir BB',
    logoInitials: 'İBB',
    logoUrl: REFERENCE_CLIENT_LOGOS.izmirBb,
    sector: 'Municipality',
    active: true,
    order: 9,
  },
  {
    id: 'rc-010',
    name: 'Ankara Kalkınma Ajansı',
    shortName: 'ANKARAKA',
    logoInitials: 'AKA',
    logoUrl: REFERENCE_CLIENT_LOGOS.ankaraka,
    sector: 'Development Agency',
    active: true,
    order: 10,
  },
  {
    id: 'rc-011',
    name: 'Türk-Alman Ticaret ve Sanayi Odası',
    shortName: 'AHK Türkei',
    logoInitials: 'AHK',
    logoUrl: REFERENCE_CLIENT_LOGOS.ahkTurkei,
    sector: 'Chamber of Commerce',
    active: true,
    order: 11,
  },
  {
    id: 'rc-012',
    name: 'Green Anatolia Energy',
    shortName: 'Green Anatolia',
    logoInitials: 'GAE',
    logoUrl: REFERENCE_CLIENT_LOGOS.greenAnatoliaEnergy,
    sector: 'Renewable Energy',
    active: true,
    order: 12,
  },
];
